import { isEqual } from 'lodash';
import { memo } from 'react';

import {
  PrivateGalleryBoard,
  type PrivateGalleryBoardProps,
} from '~/components/v2/components/board/gallery/PrivateGalleryBoard';
import { usePrivateBoardAncestorsString } from '~/components/v2/hooks/usePrivateBoardAncestorsString';

export type SearchPageGalleryBoardProps = Pick<PrivateGalleryBoardProps, 'box' | 'data' | 'index'>;

export const SearchPageGalleryBoard = memo(({ box, data, index }: SearchPageGalleryBoardProps) => {
  const { ancestorsString } = usePrivateBoardAncestorsString({
    ancestors: data.ancestors,
    library: data.library,
  });

  return <PrivateGalleryBoard ancestors={ancestorsString} box={box} data={data} index={index} />;
}, isEqual);

SearchPageGalleryBoard.displayName = 'SearchPageGalleryBoard';
